/**
 * Copyright (C) SiteVision AB 2002-2023, all rights reserved
 */
import { hasPortlet } from '../util/findPortlets';

if (hasPortlet('sv-rating-portlet')) {
  import(/* webpackChunkName: "ratings" */ './ratings');
}
